import { SaveInformation, SavePatientInformation } from "../models/Patient";

export enum PatientInformationActionDispatchTypes {
  GET_PATIENT_INFORMATION_INVOKE = "GET_PATIENT_INFORMATION_INVOKE",
  GET_PATIENT_INFORMATION_RESET = "GET_PATIENT_INFORMATION_RESET",
  GET_PATIENT_INFORMATION_SUCCESS = "GET_PATIENT_INFORMATION_SUCCESS",

  PUT_PATIENT_INFORMATION_ERROR = "PUT_PATIENT_INFORMATION_ERROR",
  PUT_PATIENT_INFORMATION_INVOKE = "PUT_PATIENT_INFORMATION_INVOKE",
  PUT_PATIENT_INFORMATION_SUCCESS = "PUT_PATIENT_INFORMATION_SUCCESS",
  PUT_PATIENT_INFORMATION_RESET = "PUT_PATIENT_INFORMATION_RESET",
}

export enum ValidatePatientSubscriberIdInfoActionDispatchTypes {
  POST_VALIDATE_PATIENT_SUBSCRIBER_ID_INVOKE = "POST_VALIDATE_PATIENT_SUBSCRIBER_ID_INVOKE",
  POST_VALIDATE_PATIENT_SUBSCRIBER_ID_SUCCESS = "POST_VALIDATE_PATIENT_SUBSCRIBER_ID_SUCCESS",
  POST_VALIDATE_PATIENT_SUBSCRIBER_ID_RESET = "POST_VALIDATE_PATIENT_SUBSCRIBER_ID_RESET",
  POST_VALIDATE_PATIENT_SUBSCRIBER_ID_ERROR = "POST_VALIDATE_PATIENT_SUBSCRIBER_ID_ERROR"
}

export enum ValidatePatientMbiInfoActionDispatchTypes {
  POST_VALIDATE_PATIENT_MBI_INVOKE = "POST_VALIDATE_PATIENT_MBI_INVOKE",
  POST_VALIDATE_PATIENT_MBI_SUCCESS = "POST_VALIDATE_PATIENT_MBI_SUCCESS",
  POST_VALIDATE_PATIENT_MBI_RESET = "POST_VALIDATE_PATIENT_MBI_RESET",
  POST_VALIDATE_PATIENT_MBI_ERROR = "POST_VALIDATE_PATIENT_MBI_ERROR"
}

export enum IntakeStageIdActionDispatchTypes {
  GET_INTAKE_STAGE_ID_INVOKE = "GET_INTAKE_STAGE_ID_INVOKE",
  GET_INTAKE_STAGE_ID_RESET = "GET_INTAKE_STAGE_ID_RESET",
  GET_INTAKE_STAGE_ID_SUCCESS = "GET_INTAKE_STAGE_ID_SUCCESS",
}

export enum PatientInformationReceivedActionDispatchTypes {
  INFORMATION_RECEIVED_INVOKE = "INFORMATION_RECEIVED_INVOKE",
  INFORMATION_RECEIVED_SUCCESS = "INFORMATION_RECEIVED_SUCCESS",
  INFORMATION_RECEIVED_RESET = "INFORMATION_RECEIVED_RESET",
  INFORMATION_RECEIVED_ERROR = "INFORMATION_RECEIVED_ERROR",
}

export const GetPatientInfo: SavePatientInformation = {
  createPatient: {
    patientId: 0,
    firstName: "",
    middleName: "",
    lastName: "",
    gender: "",
    dateOfBirth: "",
    userCreated: null,
    cellPhone: "",
    phoneNo: "",
    extNo: "",
    emailAddress: "",
    isManual: false,
  },
  patientResidentialAddress: {
    streetName1: null,
    streetName2: null,
    county: null,
    city: null,
    patientState: null,
    zipCode: null,
    latitude: null,
    longitude: null,
    addressTypeId: 1,
    country: null,
  },
  patientMailingAddress: {
    streetName1: null,
    streetName2: null,
    county: null,
    city: null,
    patientState: null,
    zipCode: null,
    latitude: null,
    longitude: null,
    addressTypeId: 3,
    country: null,
  },
  informationReceived: {
    ahcccsId: null,
    effectiveDate: "",
    effectiveThrough: "",
    eligibilityStatus: "",
    healthPlan: "",
    benefitPlanName: "",
    healthPlanState: "",
    medicareBeneficiaryIdentifier: "",
    patientId: 0,
    policyId: "",
    product: "",
    subscriberId: "",
    benefitPlanUid: "",
    healthPlanUid: "",
    apiEligibilityId: "",
    eligibilityPayerId: "",
    eligibilityPayerName: "",
    isManual: false,
    alternatePhone: "",
    contractIdPbp: null,
    subscriberSuffix: null,
    accommodationName: null,
    languagePreferenceValue: null,
    relationshipTypeId: null,
    subscriberGender: null,
    subscriberFirstName: null,
    subscriberLastName: null,
    subscriberDateOfBirth: null,
    groupPlanId: null,
    subscriberPrefix: null,
  },
  eligibilityPcp: {
    physicianName: "",
    physicianNpiId: "",
    physicianState: "",
    streetName1: "",
    zipCode: "",
    city: ""
  }
};

export const UpdateEligibilityForm: SaveInformation = {
  informationReceived: {
    ahcccsId: null,
    effectiveDate: "",
    effectiveThrough: "",
    eligibilityStatus: "",
    healthPlan: "",
    benefitPlanName: "",
    healthPlanState: "",
    medicareBeneficiaryIdentifier: null,
    patientId: 0,
    product: "",
    subscriberId: "",
    benefitPlanUid: "",
    healthPlanUid: "",
    apiEligibilityId: "",
    eligibilityPayerId: "",
    eligibilityPayerName: "",
    isManual: false,
    alternatePhone: null,
    contractIdPbp: "",
    subscriberSuffix: null,
    accommodationName: "",
    languagePreferenceValue: null,
    relationshipTypeId: null,
    subscriberGender: null,
    subscriberFirstName: null,
    subscriberLastName: null,
    subscriberDateOfBirth: null,
    groupPlanId: null,
    subscriberPrefix: null,
  },
  patientResidentialAddress: {
    streetName1: null,
    streetName2: null,
    county: null,
    city: null,
    patientState: null,
    zipCode: null,
    latitude: null,
    longitude: null,
    addressTypeId: 1,
    country: null,
  },
  patientMailingAddress: {
    streetName1: null,
    streetName2: null,
    county: null,
    city: null,
    patientState: null,
    zipCode: null,
    latitude: null,
    longitude: null,
    addressTypeId: 3,
    country: null,
  },
  eligibilityPcp: {
    physicianName: "",
    physicianNpiId: "",
    physicianState: "",
    streetName1: "",
    zipCode: "",
    city: ""
  }
};

export enum EligibilityInformation {
  UPDATE = "UPDATE ELIGIBILITY INFORMATION:",
  ADD = "ADD ELIGIBILITY INFORMATION",
}

export enum PayerIdInfo {
  BCBS_MICHIGAN_HEALTHPLAN_UID = "178da7dd-8465-4391-b252-0b2539fdc1e5",
  BCBS_TN_HEALTHPLAN_UID = "D0F1B1FE-7FA3-47DE-9F9C-DF24738EDEB9",
}
